import { put, select } from 'redux-saga/effects'
import { AppActions, AppSelectors } from '../reducers/AppRedux'
import { AuthActions } from '../reducers/AuthRedux'
import { EntityClassesActions } from '../reducers/EntityClassesRedux'
import { EntityTypesActions } from 'src/reducers/EntityTypesRedux'
import i18n from '../i18n'

export function* startup() {
  const language = yield select(AppSelectors.language)
  yield i18n.changeLanguage(language)
  yield put(AuthActions.checkRequest())
}

export function* ready() {
  yield put(AppActions.startupSuccess())
  yield put(EntityClassesActions.findRequest())
  yield put(EntityTypesActions.findRequest())
}

export function* setLanguage({ payload }) {
  yield i18n.changeLanguage(payload)
}
